import ImageWithText from "./ImageWithText";
import PageContainer from "./layout/PageContainer";
import homepageFrozenImage from "../images/tree-latest.webp";
import homepageImage3 from "../images/beautifuldurian.webp";
import malaysiaFlag from "../images/malaysia.webp";
import { Button, createStyles, rem, Group, Text } from "@mantine/core";
import { IconBrandWhatsapp } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import Reveal from "./Reveal";
import { homePrimaryButton, homeOutlineOnDarkButton } from "./homeButtonStyles";

const useStyles = createStyles((theme) => ({
  ctaSection: {
    paddingTop: rem(40),
    paddingBottom: rem(44),
    textAlign: "center",
    backgroundColor: theme.colors.gray[8],
    color: theme.white,
  },
  ctaTitle: {
    fontFamily: theme.headings?.fontFamily || '"Noto Serif TC", serif',
    fontSize: "clamp(1.35rem, 2.5vw, 1.75rem)",
    fontWeight: 600,
    letterSpacing: "0.04em",
    marginBottom: theme.spacing.sm,
  },
  ctaSubtitle: {
    color: theme.colors.gray[3],
    fontSize: theme.fontSizes.md,
    lineHeight: 1.7,
    maxWidth: 480,
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: theme.spacing.lg,
  },
  primaryBtn: homePrimaryButton(theme),
  outlineBtn: homeOutlineOnDarkButton(theme),
}));

function HomePageContent() {
  const { classes } = useStyles();

  return (
    <>
      <ImageWithText
        image={homepageFrozenImage}
        imageAlt="馬來西亞榴槤果園"
        title="馬來西亞直送榴槤"
        titleFlag={malaysiaFlag}
        body="與彭亨州及檳城產區果園合作，每週空運新鮮榴槤到港。D197 貓山王、D200 黑刺等頂級品種，歡迎批發及零售預訂。"
        ctaLabel="瀏覽鮮果"
        ctaTo="/product?category=fresh"
      />

      <ImageWithText
        image={homepageImage3}
        imageAlt="馬來西亞新鮮榴槤"
        title="急凍產品"
        body="急凍果肉及榴槤泥全年穩定供應，適用於甜品店、餐廳及烘焙生產。預約送貨，香港直送。"
        ctaLabel="瀏覽急凍產品"
        ctaTo="/product?category=frozen"
        altBackground
      />

      <section className={classes.ctaSection}>
        <PageContainer>
          <Reveal>
            <Text className={classes.ctaTitle}>立即查詢訂購</Text>
          </Reveal>
          <Reveal delay={100}>
            <Text className={classes.ctaSubtitle}>
              批發、零售、試板預約 — 歡迎 WhatsApp 或致電，我們的團隊將盡快回覆。
            </Text>
          </Reveal>
          <Reveal delay={200}>
          <Group position="center" spacing="sm">
            <Link to="/contact" style={{ textDecoration: "none" }}>
              <Button className={classes.primaryBtn} size="md" radius="md" leftIcon={<IconBrandWhatsapp size={18} />}>
                WhatsApp 9831 2915
              </Button>
            </Link>
            <Link to="/contact" style={{ textDecoration: "none" }}>
              <Button className={classes.outlineBtn} variant="outline" size="md" radius="md">
                聯絡我們
              </Button>
            </Link>
          </Group>
          </Reveal>
        </PageContainer>
      </section>
    </>
  );
}

export default HomePageContent;
